// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3xosK","title":"ClientInsurance_title__12kH6","itemText":"ClientInsurance_itemText__1Guwb"};